import styled from 'styled-components';

//helpers
import { screen } from '@/helpers/screen';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';

//theme
import { homeColor } from '@/theme/ai';

//components
import { Section } from '@/containers-ai/SectionHeading';

export const TheaterSection = styled(Section)`
  background: ${homeColor.bg};
`;

export const Theater = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 30px;

  ${screen.lg} {
    flex-direction: row;
    align-items: stretch;
    gap: 34px;
  }
`;

export const Tabs = styled.div`
  display: flex;
  flex-direction: column;

  ${screen.lg} {
    width: 340px;
    flex: none;
  }
`;

export const Tab = styled.button`
  display: flex;
  gap: 12px;
  align-items: flex-start;
  text-align: left;
  padding: 15px 16px;
  border: none;
  border-left: 2px solid
    ${(props) => (props.$active ? homeColor.green : 'rgba(234,244,241,0.18)')};
  background: none;
  cursor: pointer;
  font: inherit;
`;

export const TabNumber = styled.span`
  font-family: ${getToken('font-family-default')};
  font-size: 12px;
  color: ${(props) => (props.$active ? homeColor.green : homeColor.muted2)};
  flex: none;
`;

export const TabTitle = styled.p`
  font-family: ${getToken('font-family-default')};
  font-weight: 600;
  font-size: 14px;
  color: ${(props) => (props.$active ? homeColor.white : homeColor.muted)};
  margin: 0;
`;

export const TabSubtitle = styled.p`
  font-family: ${getToken('font-family-default')};
  font-size: 13px;
  color: ${homeColor.muted2};
  margin: 2px 0 0;
`;

export const StageBox = styled.div`
  background: rgba(234, 244, 241, 0.04);
  border: 1px solid rgba(20, 213, 77, 0.16);
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
`;

export const StageHead = styled.div`
  background: rgba(0, 0, 0, 0.25);
  border-bottom: 1px solid rgba(20, 213, 77, 0.16);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
`;

export const StageHeadTitle = styled.p`
  font-family: ${getToken('font-family-default')};
  font-weight: 600;
  color: ${homeColor.white};
  font-size: 14px;
  margin: 0 0 3px;
`;

export const StageHeadTag = styled.p`
  font-family: ${getToken('font-family-default')};
  color: ${homeColor.muted2};
  font-size: 11px;
  letter-spacing: 0.06em;
  margin: 0;
`;

export const StageStatus = styled.span`
  border-radius: 999px;
  padding: 7px 14px;
  font-family: ${getToken('font-family-default')};
  font-weight: 600;
  font-size: 11px;
  letter-spacing: 0.07em;
  flex: none;

  ${(props) =>
    props.$done
      ? `
    background: rgba(20, 213, 77, 0.1);
    border: 1px solid rgba(20, 213, 77, 0.45);
    color: ${homeColor.green};
  `
      : `
    background: rgba(0, 215, 215, 0.08);
    border: 1px solid rgba(0, 215, 215, 0.45);
    color: ${homeColor.cyan};
  `}
`;

export const StageLog = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 14px 16px;
  min-height: 238px;
`;

export const LogRow = styled.div`
  display: flex;
  gap: 10px;
  align-items: flex-start;
  padding: 8px;
  border-radius: 10px;
  background: ${(props) =>
    props.$highlight ? 'rgba(20, 214, 77, 0.1)' : 'transparent'};
  opacity: 0;
  transform: translateY(4px);
  transition:
    opacity 0.4s,
    transform 0.4s;

  ${(props) =>
    props.$show &&
    `
    opacity: 1;
    transform: none;
  `}
`;

export const LogTime = styled.p`
  font-family: ${getToken('font-family-default')};
  color: ${homeColor.muted2};
  font-size: 12px;
  margin: 0;
  flex: none;
  white-space: nowrap;
`;

export const LogText = styled.p`
  font-family: ${getToken('font-family-default')};
  font-size: 12px;
  margin: 0;
  color: ${(props) => (props.$highlight ? homeColor.green : homeColor.muted)};
`;

export const StageSummary = styled.div`
  margin: 0 16px 14px;
  padding: 12px 15px;
  border: 1px solid ${homeColor.line2};
  border-radius: 12px;
  background: hsla(150, 70%, 10%, 0.35);
  font-family: ${getToken('font-family-default')};
  font-size: 14px;
  color: ${homeColor.muted};
  line-height: 1.55;
  opacity: 0;
  transform: translateY(6px);
  transition:
    opacity 0.5s,
    transform 0.5s;

  b {
    color: ${homeColor.white};
    font-weight: 600;
  }

  ${(props) =>
    props.$show &&
    `
    opacity: 1;
    transform: none;
  `}
`;

export const StageSummaryLabel = styled.span`
  display: block;
  font-family: ${getToken('font-family-default')};
  font-size: 9px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: ${homeColor.green};
  font-weight: 700;
  margin-bottom: 6px;
`;

export const StageFoot = styled.div`
  margin-top: auto;
  border-top: 1px solid rgba(20, 213, 77, 0.16);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  font-family: ${getToken('font-family-default')};
  color: ${homeColor.muted2};
  font-size: 10px;
`;
